import {userService} from '../../services/user';
import {user} from './user';
import {ck} from 'fire-wind-water';
import {settings} from '../../common/setting';

export function removeSession(){
  ck.removeCookie(`smarketMember_${settings.schemaId}`, {path: '/', domain: 'smarket.net.cn'});
  user.memberId = null;
  user.session = null;
}

export function checkSess() {
  userService.checkSess({
    globalUserId: user.globalUserId,
    sess: user.session
  }, (res) => {
    if(res.result === 401){
      removeSession();
    }
  });
}